import { render, staticRenderFns } from "./TableCellGeneric.vue?vue&type=template&id=b2fc2e20&scoped=true"
import script from "./TableCellGeneric.vue?vue&type=script&lang=ts"
export * from "./TableCellGeneric.vue?vue&type=script&lang=ts"
import style0 from "./TableCellGeneric.vue?vue&type=style&index=0&id=b2fc2e20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fc2e20",
  null
  
)

export default component.exports